import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import { Link } from "react-router-dom";
export default function Footer() {
    return (_jsx("footer", { style: {
            marginTop: 40,
            padding: "22px 16px",
            borderTop: "1px solid rgba(255,255,255,0.08)",
            opacity: 0.9,
        }, children: _jsxs("div", { style: {
                maxWidth: 980,
                margin: "0 auto",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "flex-start",
                gap: 16,
                flexWrap: "wrap",
            }, children: [_jsxs("div", { style: { display: "flex", flexDirection: "column", gap: 6 }, children: [_jsxs("div", { style: { fontSize: 13, opacity: 0.85 }, children: ["\u00A9 ", new Date().getFullYear(), " lumia.ink"] }), _jsx("div", { style: { fontSize: 12, opacity: 0.7, lineHeight: 1.4 }, children: "This site is reader-supported. Nothing is hidden or optimised to manipulate you." })] }), _jsxs("nav", { style: { display: "flex", gap: 14, alignItems: "center", flexWrap: "wrap" }, children: [_jsx(Link, { to: "/support", style: { textDecoration: "none", color: "inherit" }, children: "Support" }), _jsx(Link, { to: "/subscribe", style: { textDecoration: "none", color: "inherit" }, children: "Subscribe" }), _jsx(Link, { to: "/contact", style: { textDecoration: "none", color: "inherit" }, children: "Contact" }), _jsx("a", { href: "/rss.xml", style: { textDecoration: "none", color: "inherit" }, children: "RSS" })] })] }) }));
}
